/**
 * ## jQueryAccordion module Usage
 *
 * ### Markup:
 * <dl class="accordion">
 *   <dt data-id="tab1"><h3><a href="#tab1">Tab Title</a></h3></dt>
 *   <dd>Panel Content</dd>
 *   <dt data-id="tab1"><h3><a href="#tab2">Tab Title</a></h3></dt>
 *   <dd>Panel Content</dd>
 * </dl>
 *
 * ### JS:
 * $.fn.accordion = require('./jquery.accordion.js');
 * $('dl.accordion').accordion();
 */
export default (($) => {

  return function(accordionName, tabElement) {

    //VARIABLES
    const $tabs = $('dl.' + accordionName + ' dt'),
          hashtag = window.location.hash,
          panelId = window.location.hash.replace('#','');

    //FUNCTIONS
    const toggleAccPanelFn = function( $this_hash, $this_tab, $this_panel ){
      if( $this_tab.hasClass('active') && $this_panel.is(':visible') ){

        $this_panel.slideUp();
        $this_tab.removeClass('active').addClass('inactive');
      }
      else{
        //close open panels
        $this_tab.parent().find('dt.active').removeClass('active').addClass('inactive').next().slideUp();
        //open this accordion panel
        $this_panel.slideDown();
        $this_tab.addClass('active').removeClass('inactive');
        if(tabElement === 'a'){ window.location.hash = $this_hash; }
      }

    }

    //TAB ANCHOR CLICKS
    $tabs.find(tabElement).on('click', function(e){
      e.preventDefault()
      const this_hash = $(this).attr('href');
      const this_tab = $(this).closest('dt');
      const this_panel = this_tab.next();

      toggleAccPanelFn(this_hash, this_tab, this_panel);
    });

    //PRESELECTED OPEN PANEL (USE OF HASHTAGS)
    if( hashtag && tabElement === 'a' && $('dl.' + accordionName + ' dt[data-id="'+panelId+'"]').length>0 ){
      
      const selected_tab = $('dl.' + accordionName + ' dt[data-id="'+panelId+'"]');
      const selected_panel = selected_tab.next();
      const accordionPos = selected_tab.offset().top;
      
      //open panel
      toggleAccPanelFn(hashtag, selected_tab, selected_panel)

      //set scroll position to the open accordion panel
      $(document).scrollTop(accordionPos);
      //$('html, body').animate({ scrollTop: accordionPos }, 500);

    }
  }

})(jQuery)
